import clsx from "clsx";
import React, { useEffect, useState } from "react";

import { Select } from "@transfr-inc/dashboard-components/forms";

import { useApiRequest } from "@lib/hooks";
import { getClassroomsStats } from "@services/classroom.utils";
import { useContainer } from "@src/contexts/container-context";

import { ClassroomOptionItem } from "./classroom-option-item";

export function ClassroomFilter({
  className,
  onClassroomSelected,
  orgCode,
  placeholder = "Filter by Classroom",
  product,
  professionalLearning = false,
  role,
  selectedClassrooms = [],
  userId,
}) {
  const [classrooms, setClassrooms] = useState([]);

  const { classroomService } = useContainer();
  const { response } = useApiRequest(() =>
    getClassroomsStats({ classroomService, userId, role, orgCode })
  );

  useEffect(() => {
    if (response) {
      let classrooms = response ?? [];
      if (product) {
        classrooms = classrooms.filter((classrooom) =>
          classrooom.products?.includes(product)
        );
      }
      classrooms = classrooms.filter(
        (classroom) => classroom.isProfessionalLearning === professionalLearning
      );

      setClassrooms(
        classrooms.map((classroom) => new ClassroomOptionItem(classroom))
      );
    }
  }, [response, product, professionalLearning]);

  return (
    <Select
      className={clsx("classroom-filter", className)}
      icon={["fa-light", "fa-magnifying-glass"]}
      onOptionsChange={(classrooms) =>
        onClassroomSelected(classrooms.length > 0 ? classrooms : undefined)
      }
      options={classrooms}
      placeholder={placeholder}
      searchEnabled
      selected={selectedClassrooms}
    />
  );
}
